var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2C2E32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67963 3.58353L6.55605 2.70711C6.94658 2.31658 7.57974 2.31658 7.97026 2.70711L10.7666 5.50342C11.1571 5.89394 11.1571 6.52711 10.7666 6.91763L8.84261 8.8416C8.528 9.15621 8.45 9.63685 8.64898 10.0348C9.79925 12.3353 11.6647 14.2007 13.9652 15.351C14.3632 15.55 14.8438 15.472 15.1584 15.1574L17.0824 13.2334C17.4729 12.8429 18.1061 12.8429 18.4966 13.2334L21.2929 16.0297C21.6834 16.4203 21.6834 17.0534 21.2929 17.4439L20.4165 18.3204C18.3051 20.4317 14.9625 20.6693 12.5738 18.8777L10.9444 17.6556C9.20083 16.348 7.65201 14.7992 6.34436 13.0556L5.12226 11.4262C3.33072 9.03745 3.56827 5.69488 5.67963 3.58353Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.a3ec2d8a61ac8a84e171c009f6564622.svg";
export { ForwardRef as ReactComponent };